import React from 'react';
import Form from './Form'
const Home = () => {
  return <div className='home'>
      <Form/>
  </div>;
};

export default Home;
